import beginningBalance from '@/api/beginning-balance'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  users: [],
  currencies: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_USERS(state, data) {
    state.users = data
  },
  SET_CURRENCIES(state, data) {
    state.currencies = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return beginningBalance.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return beginningBalance.store(data)
  },

  async find(context, id) {
    return await beginningBalance.find(id)
  },

  update(context, data) {
    return beginningBalance.update(data)
  },

  delete(context, data) {
    return beginningBalance.destroy(data)
  },

  async dataBeforeCreate(context) {
    if (!context.state.users.length > 0) {
      let response = await beginningBalance.getUser()
      context.commit('SET_USERS', response)
    }
    if (!context.state.currencies.length > 0) {
      let response = await beginningBalance.getCurrency()
      context.commit('SET_CURRENCIES', response)
    }
  }
}
